import {Client, Country, Event, Order, PaymentMethod, Product, Slot, State, Title, User, VisitorSegment} from '../Models';
import {RootState} from './typings';
import {CartDTO, CustomerDataDTO, SessionDTO} from '../DTOs';

export const getters = {
  getCurrentOrder(state: RootState): Order | null {
    if (state.cart) {
      return state.cart.order;
    }
    return null;
  },
  getCart(state: RootState): CartDTO | null {
    return state.cart;
  },
  getEvents(state: RootState): Array<Event> {
    return state.events;
  },
  getProducts(state: RootState): Array<Product> {
    return state.products;
  },
  getClients(state: RootState): Array<Client> {
    return state.clients;
  },
  getSlots(state: RootState): Array<Slot> {
    return state.slots;
  },
  getExhibitorNames(state: RootState): Array<string> {
    return state.exhibitorData ? state.exhibitorData.names : [];
  },
  getExhibitorAdvertisings(state: RootState): any {
    return state.exhibitorData ? state.exhibitorData.advertising : {};
  },
  getVisitorSegments(state: RootState): Array<VisitorSegment> {
    return state.visitorSegments;
  },
  getUserLanguage(state: RootState): string | null {
    return state.language;
  },
  getUser(state: RootState): User | null {
    return state.user;
  },
  getBuyerData(state: RootState): CustomerDataDTO | null {
    return state.buyerData;
  },
  getIsGuestOrder(state: RootState): boolean | null {
    return state.isGuestOrder;
  },
  getSession(state: RootState): SessionDTO | null {
    return state.session;
  },
  getCurrentRegistrationCodes(state: RootState): Array<string> | null {
    return state.registrationCodes;
  },
  getCountries(state: RootState): Array<Country> {
    return state.countries;
  },
  getStates(state: RootState): { [key: string]: Array<State> } {
    return state.states;
  },
  getTitles(state: RootState): Array<Title> {
    return state.titles;
  },
  getEnableTicketShop(state: RootState): boolean {
    return state.enableTicketShop;
  },
  getLoginReturnUrl(state: RootState): string | null {
    return state.loginReturnUrl;
  },
  getPaymentMethods(state: RootState): Array<PaymentMethod> | null {
    return state.paymentMethods;
  },
};
